module.exports = __webpack_public_path__ + "7163ed839bbf3ad33ae9a900434bc7f9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-mastercard.svg
// module id = d61K
// module chunks = 5